import { Alert, Col, Flex, Row, Switch, Tooltip, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Button from "../../../../../../Components/Button"
import Input from "../../../../../../Components/Input"
import Icon from "../../../../../../Icon"

import dim from "../dimmed.module.less"
import styles from "./autoApproveSection.module.less"

const { Text } = Typography

const AutoApproveSection = ({ locked, summary, delayDays, onEdit }) => {
  const { t } = useTranslation()

  return (
    <Row gutter={[24, 24]}>
      <Col flex="1 1 300px">
        <Flex vertical gap={16} style={{ maxWidth: 500 }}>
          <Flex vertical gap={4}>
            <Text strong>{t("Auto-approve evidence")}</Text>
            <Text type="secondary">
              {t(
                "We submit your evidence automatically ahead of each deadline. Set which disputes are auto-submitted and how many days we wait first."
              )}
            </Text>
          </Flex>
          <Alert
            type="warning"
            showIcon
            icon={<Icon type="alert_triangle_error" style={{ fontSize: 20 }} />}
            message={<Text strong>{t("Pay attention")}</Text>}
            description={
              <Text>
                {t(
                  "Auto-approve uses template evidence only. Spot-check a few PDFs each week so disputes that need a custom touch don’t slip through."
                )}
              </Text>
            }
          />
        </Flex>
      </Col>

      <Col flex="0 1 420px">
        <Flex vertical gap={8} className={locked ? dim.dimmed : ""}>
          <Flex gap={12} align="center">
            {/* Auto-submission is always on and cannot be turned off: the switch is
                checked and disabled so its state reads as fixed. The tooltip explains
                WHY it can't be moved (and where to go instead), so the disabled
                control isn't just a dead end. A disabled antd Switch swallows pointer
                events, hence the wrapper span that receives the hover. */}
            <Tooltip
              title={t(
                "Auto-submission cannot be turned off: it is how Recover fights your disputes. To stop specific disputes being submitted, add an auto-submission exception below."
              )}
            >
              <span className={styles.switchWrap}>
                <Switch checked disabled />
              </span>
            </Tooltip>
            <Text>{t("Auto-submission")}</Text>
          </Flex>
          <Flex gap={12}>
            <Input
              addonBefore={<Text type="secondary">$</Text>}
              value={summary}
              disabled
              style={{ width: "100%" }}
            />
            <Button size="large" disabled={locked} onClick={onEdit} text={t("Edit")} />
          </Flex>
          <Text type="secondary" style={{ fontSize: 14 }}>
            {Number(delayDays) === 1
              ? t("Evidence is sent 1 day before the deadline.")
              : t("Evidence is sent _days_ days before the deadline.", { days: delayDays })}
          </Text>
        </Flex>
      </Col>
    </Row>
  )
}

export default AutoApproveSection
